import $ from 'jquery';
import RGBColor from 'rgbcolor';
import * as _ from 'lodash';
import assert from 'assert';
import { util } from './util';
import { userinfo } from './userinfo';
import { drawing } from './drawing';
import { DropdownCalendar } from './DropDownCalendar';
import { DropdownToolList } from './DropDownToolList';
import { api } from './api';
import { fileSizeCheck, fileTypeCheck } from '../../utilities/fileType';
import { messageUtility } from '../../utilities/messageUtility';
import { isIPad } from '../../utilities/commonUtil';
import { EventType } from '../../utilities/EventManager';

/* eslint-disable no-unused-vars */
// jQuery併用のためにこの変数は未使用でも import する必要がある
import { $Palette } from './palette';
import { $Tooltip } from './tooltip';
/* eslint-enable no-unused-vars */
import {
  isPrimaryCompany,
  isPartnerCompany,
} from '../../utilities/roleUtility';
import { fabric } from 'fabric';
import { split } from '../constructionPlacement/split';
import { cropperImage } from './crop-image';
import { places } from '../constructionPlacement/places';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import { handleRedoPath, handleUndoPath } from './freehandUtil';

function _ui() {
  this.currentDate = null;
  this.toolboxCollapsed = false;
  this.isHidingToolbox = false;

  // 初期化
  this.init = function(currentDate) {
    let self = this;
    self.toolboxCollapsed = false;
    $('[name=hedder_date]').val(util.dataFormat(currentDate, 'YYYY/MM/DD'));
    this.currentDate = currentDate;

    if (isPrimaryCompany(userinfo.getUserType())) {
      $('.sys_lock_room').show();
    }

    // キーボード操作
    $(document).on('keydown', function(e) {
      e.stopImmediatePropagation();
      if (
        ['tool-print-range', 'tool-point'].includes(drawing._toolbox_selected)
      ) {
        // 印刷範囲指定やポインタモードの場合はキーボードでの操作は受け付けない
        return;
      }
      if (split._splited) {
        // Keyboard operations are not accepted when the screen is split
        return;
      }
      if (self.isHidingToolbox) {
        // Keyboard operations are not accepted when the toolbox is hidden (locked foreman or isExtraProxiLogin)
        return;
      }
      if (['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {
        return;
      }

      var key;
      if (window.event) {
        key = window.event.keyCode;
      } else {
        key = e.keyCode;
      }

      const { isSelect, isLock } = drawing.getSelectionStatus(drawing._target);

      drawing.debug('key:down', isLock);

      switch (key) {
        // Pan (Space)
        case 32:
          e.preventDefault();
          // If user is drawing polygon or polyline,
          // select tool-select
          // else, select tool-pan
          if (
            drawing._making &&
            (drawing._toolbox_selected === 'tool-polygon' ||
              drawing._toolbox_selected === 'tool-polyline')
          ) {
            ui.toolboxSelect('tool-select');
          } else {
            ui.toolboxSelect('tool-pan');
          }
          break;
        // Copy (Ctrl+C)/円（C）
        case 67:
          e.preventDefault();
          if (isSelect) {
            if (e.ctrlKey) {
              drawing.copy();
              break;
            }
          }
          ui.toolboxSelect('tool-circle');
          break;
        // 扇形(F)
        case 70:
          e.preventDefault();
          ui.toolboxSelect('tool-sector');
          break;
        // Text (T)
        case 84:
          e.preventDefault();
          ui.toolboxSelect('tool-font');
          break;
        // Cut (Ctrl+X)
        case 88:
          if (isSelect && !isLock) {
            if (e.ctrlKey) {
              e.preventDefault();
              drawing.copy(true);
            }
          }
          break;
        // Paste (Ctrl+V)
        case 86:
          if (drawing._clip) {
            if (e.ctrlKey) {
              e.preventDefault();
              drawing.paste();
            }
          }
          break;
        // Select (A) / Select All (Ctrl+A)
        case 65:
          if (e.ctrlKey) {
            e.preventDefault();
            drawing.selectAll();
          } else {
            // Select
            e.preventDefault();
            ui.toolboxSelect('tool-select');
          }
          break;
        // Delete
        case 46:
          if (isSelect && !isLock) {
            e.preventDefault();
            drawing.deleteSelection();
          }
          break;
        // Redo（Ctrl+Y）
        case 89:
          if (e.ctrlKey) {
            e.preventDefault();
            if (drawing._toolbox_selected === 'tool-freehand') {
              handleRedoPath();
              drawing.setToolbarItem();
            } else if (drawing._toolbox_selected !== 'tool-print-range') {
              drawing.redo();
            }
          }
          break;
        // Undo (Ctrl+Z)
        case 90:
          if (e.ctrlKey) {
            e.preventDefault();
            if (drawing._toolbox_selected === 'tool-freehand') {
              handleUndoPath();
              drawing.setToolbarItem();
            } else if (drawing._toolbox_selected !== 'tool-print-range') {
              drawing.undo();
            }
          }
          break;
        // ← 左回転(alt+←)
        case 37:
          if (isSelect && !isLock) {
            e.preventDefault();
            if (e.altKey && e.shiftKey) {
              drawing.moveRotation('left-rotation');
              break;
            }
            drawing.moveObject('left');
          }
          break;
        // ↑
        case 38:
          if (isSelect && !isLock) {
            e.preventDefault();
            drawing.moveObject('top');
          }
          break;
        // → 右回転(alt+→)
        case 39:
          if (isSelect && !isLock) {
            e.preventDefault();
            if (e.altKey && e.shiftKey) {
              drawing.moveRotation('right-rotation');
              break;
            }
            drawing.moveObject('right');
          }
          break;
        // ↓
        case 40:
          if (isSelect && !isLock) {
            e.preventDefault();
            drawing.moveObject('bottom');
          }
          break;
        //ロック/直線（L）/折れ線（Alt+L）
        case 76:
          e.preventDefault();
          if (isSelect) {
            if (e.ctrlKey && e.shiftKey) {
              if (!isLock) {
                drawing.lock();
                break;
              }
              if (isLock) {
                drawing.unlock();
                break;
              }
            }
          }
          if (e.altKey && !e.shiftKey) {
            ui.toolboxSelect('tool-polyline');
            break;
          }
          if (!e.altKey && !e.shiftKey) {
            ui.toolboxSelect('tool-line-normal');
          }
          break;
        //四角（R）
        case 82:
          e.preventDefault();
          ui.toolboxSelect('tool-square');
          break;
        //多角形（M）
        case 77:
          e.preventDefault();
          ui.toolboxSelect('tool-polygon');
          break;
        //ポインター(P)矢印ポインター(Alt+P)
        case 80:
          if ($('button').hasClass('tool-pointer-button')) {
            e.preventDefault();
            if (e.altKey) {
              ui.toolboxSelect('tool-arrow-pointer');
              break;
            }
            ui.toolboxSelect('tool-pointer');
          }
          break;
        //グループ化(Ctl+G)
        case 71:
          if (isSelect && !isLock) {
            e.preventDefault();
            if (e.ctrlKey && e.shiftKey) {
              drawing.ungroup();
              break;
            }
            if (e.ctrlKey) {
              drawing.makeGroup();
            }
          }
          break;
        //最前面(])前面(Alt+])
        case 221:
          if (isSelect && !isLock) {
            e.preventDefault();
            if (e.altKey) {
              drawing.moveFront();
              break;
            }
            drawing.moveMostFront();
          }
          break;
        //最背面([)背面(Alt+[)
        case 219:
          if (isSelect && !isLock) {
            e.preventDefault();
            if (e.altKey) {
              drawing.moveBack();
              break;
            }
            drawing.moveMostBack();
          }
          break;
        // 描画
        case 66:
          e.preventDefault();
          ui.toolboxSelect('tool-freehand');
          break;
        default:
          break;
      }
    });

    // キーボード操作
    $(document).on('keyup', function(e) {
      e.stopImmediatePropagation();
      if (
        ['tool-print-range', 'tool-point'].includes(drawing._toolbox_selected)
      ) {
        // 印刷範囲指定やポインタモードの場合はキーボードでの操作は受け付けない
        return;
      }
      if (['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {
        return;
      }

      var key;
      if (window.event) {
        key = window.event.keyCode;
      } else {
        key = e.keyCode;
      }

      const { isSelect, isLock } = drawing.getSelectionStatus(drawing._target);
      switch (key) {
        case 37: // ←
        case 38: // ↑
        case 39: // →
        case 40: // ↓
          if (isSelect && !isLock) {
            e.preventDefault();
            drawing.moveObject('commit');
          }
          break;
        default:
          break;
      }
    });

    // メッセージダイアログ閉じる
    $('#modal-dialog-popup-message .sys_cancel').click(function() {
      $('#modal-dialog-popup-message').removeClass('show');
      $('#modal-dialog-popup-message .message_text').text('');
    });
    // Active toolbar's tabs
    // The object editing tab can only be active when some objects have been selected
    $('.layout-tool-tabs ul li').click(function() {
      let disable = $(this).hasClass('disable');
      if (!disable) {
        let tab_id = $(this).attr('data-tab');
        $('.layout-tool-tabs ul li').removeClass('active');
        $('.tab-content').removeClass('active');
        $(this).addClass('active');
        $(`${'.layout-tool ' + '#'}${tab_id}`).addClass('active');
      }
    });

    // カレンダー
    self.dropdownCalendar = new DropdownCalendar();
    self.dropdownCalendar.init(
      'dropdown-calendar',
      'input[name=hedder_date]',
      userinfo.getFieldId()
    );
    self.dropdownSplitCalendar0 = new DropdownCalendar();
    self.dropdownSplitCalendar0.init(
      'dropdown-calendar-split-0',
      'input[name=split_view_date]',
      userinfo.getFieldId()
    );
    self.dropdownSplitCalendar1 = new DropdownCalendar();
    self.dropdownSplitCalendar1.init(
      'dropdown-calendar-split-1',
      'input[name=split_view_date]',
      userinfo.getFieldId()
    );
    self.dropdownSplitCalendar2 = new DropdownCalendar();
    self.dropdownSplitCalendar2.init(
      'dropdown-calendar-split-2',
      'input[name=split_view_date]',
      userinfo.getFieldId()
    );
    self.dropdownSplitCalendar3 = new DropdownCalendar();
    self.dropdownSplitCalendar3.init(
      'dropdown-calendar-split-3',
      'input[name=split_view_date]',
      userinfo.getFieldId()
    );
    self.dropdownSplitCalendar4 = new DropdownCalendar();
    self.dropdownSplitCalendar4.init(
      'dropdown-calendar-split-4',
      'input[name=split_view_date]',
      userinfo.getFieldId()
    );
    self.dropdownSplitCalendar5 = new DropdownCalendar();
    self.dropdownSplitCalendar5.init(
      'dropdown-calendar-split-5',
      'input[name=split_view_date]',
      userinfo.getFieldId()
    );
    self.dropdownSplitCalendar6 = new DropdownCalendar();
    self.dropdownSplitCalendar6.init(
      'dropdown-calendar-split-6',
      'input[name=split_view_date]',
      userinfo.getFieldId()
    );
    self.dropdownSplitCalendar7 = new DropdownCalendar();
    self.dropdownSplitCalendar7.init(
      'dropdown-calendar-split-7',
      'input[name=split_view_date]',
      userinfo.getFieldId()
    );
    self.dropdownSplitCalendar8 = new DropdownCalendar();
    self.dropdownSplitCalendar8.init(
      'dropdown-calendar-split-8',
      'input[name=split_view_date]',
      userinfo.getFieldId()
    );
    self.dropdownCopyCalendar = new DropdownCalendar();
    self.dropdownCopyCalendar.init(
      'dropdown-copy-calendar',
      'input[name=copy_date]',
      userinfo.getFieldId()
    );

    // 画面単独表示時(非分割時) 日付変更時
    $('[name=hedder_date]').change(function() {
      var dt = new Date($(this).val());
      var chooseDateStr = `${dt.getFullYear()}${dt.getMonth() +
        1}${dt.getDate()}`;
      var currentDateStr =
        self.currentDate.getFullYear() +
        (self.currentDate.getMonth() + 1) +
        self.currentDate.getDate();
      if (currentDateStr !== chooseDateStr) {
        drawing.places.reload(dt);

        // drawing.split.reload();
        // 分割画面ではない場合の split reload は不要

        drawing.hidePrintFrame();
        self.hidePrintRengeSetting();
      }
      self.currentDate = dt;
    });

    // ツールバー sys_tooltip項目 ボタン
    // sys_tooltip項目 = 選択/テキスト/円/四角/多角形/直線/連続した線/自由線/背景移動
    $('.sys_tooltip').click(function() {
      // ポインタリセット
      self.setPointerReset();
      // ツール設定
      if ($(this).hasClass('tool-disabled')) {
        return;
      }
      self.toolboxSelect($(this).attr('data-id'));
    });

    // ツールバー 拡大表示 ボタン
    $('.toolbar-zoomup').click(function() {
      drawing.zoomUp();
    });
    // ツールバー 縮小表示 ボタン
    $('.toolbar-zoomdown').click(function() {
      drawing.zoomDown();
    });

    // ツールバー 切り取り ボタン
    $('.toolbar-cut').click(function() {
      if (drawing._toolbox_selected !== 'tool-print-range') {
        drawing.copy(true);
      }
    });
    // ツールバー コピー ボタン
    $('.toolbar-copy').click(function() {
      if (drawing._toolbox_selected !== 'tool-print-range') {
        drawing.copy();
      }
    });
    // ツールバー 貼り付け ボタン
    $('.toolbar-paste').click(function() {
      if (drawing._toolbox_selected !== 'tool-print-range') {
        drawing.paste();
      }
    });
    // ツールバー グループ化 ボタン
    $('.toolbar-group').click(function() {
      if (drawing._toolbox_selected !== 'tool-print-range') {
        drawing.makeGroup();
        $('.label-group span').html('グループ解除');
      }
    });
    // ツールバー グループ化解除 ボタン
    $('.toolbar-ungroup').click(function() {
      if (drawing._toolbox_selected !== 'tool-print-range') {
        $('.label-group span').html('グループ化');
        drawing.ungroup();
      }
    });
    // ツールバー 最前面へ ボタン
    $('.toolbar-move-front').click(function() {
      if (drawing._toolbox_selected !== 'tool-print-range') {
        drawing.moveMostFront();
      }
    });
    // ツールバー 最背面へ ボタン
    $('.toolbar-move-back').click(function() {
      if (drawing._toolbox_selected !== 'tool-print-range') {
        drawing.moveMostBack();
      }
    });
    // ツールバー オブジェクトのロック ボタン
    $('.toolbar-lock').click(function() {
      $('.tool-setting-style').addClass('pointer-events-none');
      if (drawing._toolbox_selected !== 'tool-print-range') {
        drawing.lock();
        drawing.setToolbarItem();
        $('.label-lock span').html('ロック解除');
      }
    });
    // ツールバー オブジェクトのロック解除 ボタン
    $('.toolbar-unlock').click(function() {
      if (drawing._toolbox_selected !== 'tool-print-range') {
        drawing.unlock();
        $('.label-lock span').html('ロック');
      }
    });
    // ツールバー 削除 ボタン
    $('.toolbar-delete').click(function() {
      if (drawing._toolbox_selected !== 'tool-print-range') {
        drawing.deleteSelection();
      }
    });
    // ツールバー 1つ戻る ボタン
    $('.toolbar-undo').click(function() {
      if (drawing._toolbox_selected === 'tool-freehand') {
        handleUndoPath();
        drawing.setToolbarItem();
      } else if (drawing._toolbox_selected !== 'tool-print-range') {
        drawing.undo();
      }
    });
    // ツールバー 1つ進む ボタン
    $('.toolbar-redo').click(function() {
      if (drawing._toolbox_selected === 'tool-freehand') {
        handleRedoPath();
        drawing.setToolbarItem();
      } else if (drawing._toolbox_selected !== 'tool-print-range') {
        drawing.redo();
      }
    });

    // Click button to switch fullscreen mode
    $('.sys_fullscreen').click(function() {
      setTimeout(() => {
        split.calcMultiSplit();
      }, 150);
      if ($('.rail').hasClass('rail--layout-fullscreen')) {
        self._fullScreen = true;
        if (self.isIE()) {
          $('.layout-tool, .layout-tool-fix').css({
            left: '420px',
          });
        }
        $('.layout-header__title').css({
          textIndent: '6px',
        });
      } else {
        self._fullScreen = false;
        if (self.isIE()) {
          $('.layout-tool, .layout-tool-fix').css({
            left: '0px',
          });
        }
        $('.layout-header__title').css({
          textIndent: '16px',
        });
      }

      self.correctLayoutFooter(self._fullScreen);
    });

    // フルスクリーン時 ツールバーを閉じる リンク
    $('.toolbar-close').click(function() {
      $('.layout-tool').addClass('element__hide');
      $('.toolbar-close').hide();
      $('.toolbar-open').show();
      $('.layout-tool-fix').css({
        height: '24px',
      });
      $('.layout-grid').css({
        paddingTop: '24px',
      });
      self.toolboxCollapsed = true;
    });
    // フルスクリーン時 ツールバーを表示 リンク
    $('.toolbar-open').click(function() {
      $('.layout-tool').removeClass('element__hide');
      $('.toolbar-open').hide();
      $('.toolbar-close').show();
      $('.layout-tool-fix').css({
        height: '64px',
      });
      $('.layout-grid').css({
        paddingTop: '96px',
      });
      self.toolboxCollapsed = false;
    });

    // ツールバー 部品グループメニュー ボタン
    $('div.tool-item-list').click(function() {
      if (!$(this).hasClass('tool-crane')) {
        $(this).toggleClass('selected');
      }
      $('.Palette ._palette').removeClass('__show');
    });

    $('.tool-crane').click(function(e) {
      let classList = e.target ? e.target.classList : [];
      const classNames = [
        'select-parts-scale',
        'parts_group_edit',
        'label',
        'tool-table-menu',
        'tool-table__header',
        'parts_scale',
        'select-down',
        'select-up',
        'tool-list-normal__text',
        'tool-item--sm__header',
        'tool-table-menu__item',
      ];
      if (!classNames.some(className => classList.contains(className))) {
        $('.tool-crane__dropdown').toggleClass('selected');
        $(this).toggleClass('selected');
      }
    });

    //Close the tool item list when clicked for another
    $(document).mouseup(function(e) {
      let container = $('.tool-item-list.selected, .tool-item--sm.selected');
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(container).removeClass('selected');
      }
    });
    // ツールバー 線幅メニュー
    self.dropdownBorder = new DropdownToolList();
    self.dropdownBorder.init('dropdown-border', function(val, on_change) {
      $(this.input).val(`${String(val).replace('pt', '')}pt`);
      if (on_change) {
        drawing.setBorderWidth(String(val).replace('pt', ''));
      }
    });

    // ツールバー 線種メニュー
    self.dropdownBorderStyle = new DropdownToolList();
    self.dropdownBorderStyle.init('dropdown-border-style', function(
      val,
      on_change
    ) {
      let list = { 実線: 1, 点線: 2, 鎖線: 3 };
      $(this.input).val(val);
      if (on_change) {
        drawing.setBorderStyle(list[val]);
      }
    });

    // ツールバー 矢印メニュー
    self.dropdownBorderArrow = new DropdownToolList();
    self.dropdownBorderArrow.init('dropdown-border-arrow', function(
      val,
      on_change
    ) {
      let list = {
        0: 'i-tool-arrow-type-1',
        1: 'i-tool-arrow-type-2',
        2: 'i-tool-arrow-type-3',
        3: 'i-tool-arrow-type-4',
      };
      let { isSelectMulti } = drawing.getSelectionStatus(drawing._target);
      if (!isSelectMulti) {
        let _this = this;
        _.each(list, function(class_name) {
          $(`#${_this.dropdown_id} .selected-icon`).removeClass(class_name);
        });
        $(`#${_this.dropdown_id} .selected-icon`).addClass(list[val]);
        $(_this.input).val(val);
        if (on_change) {
          drawing.setArrowType(val);
        }
        $('.tool-arrow-type__value input').val(val);
      } else {
        if (on_change) {
          drawing.setArrowType(val);
        }
      }
      const arrowTypeSelectedContent = $(`button.${list[val]}`).html();
      $('.tool-arrow-type__input-text').html(arrowTypeSelectedContent);
    });

    // ツールバー 矢印サイズメニュー
    self.dropdownBorderArrowSize = new DropdownToolList();
    self.dropdownBorderArrowSize.init('dropdown-border-arrow-size', function(
      val,
      on_change
    ) {
      let list = {
        10: 'i-tool-arrow-size-1',
        20: 'i-tool-arrow-size-2',
        30: 'i-tool-arrow-size-3',
      };
      let { isSelectMulti } = drawing.getSelectionStatus(drawing._target);
      if (!isSelectMulti) {
        let _this = this;
        _.each(list, function(class_name) {
          $(`#${_this.dropdown_id} .selected-icon`).removeClass(class_name);
        });
        $(`#${_this.dropdown_id} .selected-icon`).addClass(list[val]);
        $(_this.input).val(val);
        if (on_change) {
          drawing.setArrowSize(val);
        }
      } else {
        if (on_change) {
          drawing.setArrowSize(val);
        }
      }
      const arrowTypeSelectedContent = $(`button.${list[val]}`).html();
      $('.tool-arrow-size__input-text').html(arrowTypeSelectedContent);
    });

    // ツールバー 透明度メニュー
    self.dropdownTransparent = new DropdownToolList();
    self.dropdownTransparent.init('dropdown-background-transparent', function(
      val,
      on_change
    ) {
      $(this.input).val(`${String(val).replace('%', '')}%`);
      if (on_change) {
        let color = new RGBColor(
          $('.toolbar-picker-background ._selected').css('background-color')
        );
        let a = (100 - parseInt(String(val).replace('%', ''))) / 100;
        drawing.setBackgroundColor(
          `rgba(${color.r},${color.g},${color.b},${a})`,
          true,
          true
        );
      }
    });

    // ツールバー 文字サイズ
    self.dropdownFontSize = new DropdownToolList();
    self.dropdownFontSize.init('dropdown-font-size', function(val, on_change) {
      $(this.input).val(`${parseInt(String(val).replace('pt', ''))}pt`);
      if (on_change) {
        drawing.setFontSize(String(val).replace('pt', ''));
      }
    });

    // dropdown list zoom level
    let zoomLevelList = {
      '25%': 0.25,
      '50%': 0.5,
      '75%': 0.75,
      '100%': 1,
      '125%': 1.25,
      '150%': 1.5,
      '175%': 1.75,
      '200%': 2,
      '250%': 2.5,
      '300%': 3,
      '400%': 4,
      '500%': 5,
      '600%': 6,
      '700%': 7,
      '800%': 8,
    };
    self.dropdownZoomLevel = new DropdownToolList();
    self.dropdownZoomLevel.init(
      'dropdown-zoom-level',
      function(val, on_change) {
        $(this.input).val(val);
        if (on_change) {
          drawing.setZoom(zoomLevelList[val]);
        }
      },
      '100%'
    );

    // ツールバー パレットメニュー
    $('.Palette').Palette();

    //Close the Palette when clicked for another
    $(document).off('mouseup.palette');
    $(document).on('mouseup.palette', function(e) {
      let container = $('.Palette ._palette.__show');

      const toggleShowPalette = className => {
        $(`.${className}`)
          .closest('.Palette')
          .find('._palette')
          .toggleClass('__show');
      };

      const removeShowPalette = classNames => {
        $(`${classNames}`)
          .closest('.Palette')
          .find('._palette')
          .removeClass('__show');
      };

      // Only show current Palette when clicked
      if (e.target.classList === undefined) {
        return;
      }
      if (e.target.classList.contains('btn-pick-color__line')) {
        const emptyColor = $('.toolbar-picker-foreground li:has(div[data-id="empty"])');
        const f2f2f2Color = $('.toolbar-picker-foreground li:has(div[data-id="f2f2f2"])');
        if (drawing.selectionHasShape()) {
          emptyColor.show();
          f2f2f2Color.hide();
        } else {
          emptyColor.hide();
          f2f2f2Color.show();
        }
        toggleShowPalette('btn-pick-color__line');
        removeShowPalette('.btn-pick-color-background, .btn-pick-color__text');
      } else if (e.target.classList.contains('btn-pick-color__text')) {
        toggleShowPalette('btn-pick-color__text');
        removeShowPalette('.btn-pick-color__line,.btn-pick-color-background');
      } else if (e.target.classList.contains('btn-pick-color-background')) {
        toggleShowPalette('btn-pick-color-background');
        removeShowPalette('.btn-pick-color__line, .btn-pick-color__text');
      }

      // Hide current Palette when user clicks outside of it
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(container).removeClass('__show');
      }
    });

    // ツールチップイベント
    $('.Tooltip').Tooltip();

    // ツールバー 線色メニュー
    $('.toolbar-picker-foreground .sys_select_color').click(function(e) {
      var color = new RGBColor(
        $('.toolbar-picker-foreground ._selected').css('background-color')
      );
      var target = e.target.className;
      if (target.match(/__empty/)) {
        drawing.setForegroundColor(`rgba(${color.r},${color.g},${color.b}, 0)`);
      } else {
        drawing.setForegroundColor(
          `rgba(${color.r},${color.g},${color.b}, 100)`
        );
      }
    });

    // ツールバー 背景色メニュー
    $('.toolbar-picker-background .sys_select_color').click(function(e) {
      var color = new RGBColor(
        $('.toolbar-picker-background ._selected').css('background-color')
      );
      var target = e.target.className;
      var a;
      if (target.match(/__empty/)) {
        a = 0;
      } else {
        a =
          (100 -
            parseInt(
              String(self.dropdownTransparent.getValue()).replace('%', '')
            )) /
          100;
        if (a === 0) {
          a = 1;
        }
      }
      drawing.setBackgroundColor(`rgba(${color.r},${color.g},${color.b},${a})`);
    });

    // ツールバー 文字色メニュー
    $('.toolbar-picker-text .sys_select_color').click(function() {
      var color = new RGBColor(
        $('.toolbar-picker-text ._selected').css('background-color')
      );
      drawing.setTextColor(color.toRGB());
    });

    // ツールバー オブジェクト情報表示 ボタン
    $('.toolbar-info').click(function() {
      $('#modal-dialog-object-info').addClass('show');
      $('.toolbar-info').addClass('selected');
    });
    $('#modal-dialog-object-info .sys_cancel').click(function() {
      $('#modal-dialog-object-info').removeClass('show');
      $('.toolbar-info').removeClass('selected');
    });

    // ツールバー 画像配置 ボタン からの画像選択ダイアログでの動作
    const imageUploadEl = $('#image-upload');
    // if user select nothing/cancel
    imageUploadEl.click(() => {
      $(window).on('blur.before-image-upload', () => {
        $(window).on('focus.image-upload', () => {
          $('[data-id="tool-image"]').removeClass('selected');
          setTimeout(() => {
            ui.toolboxSelect('tool-select');
            $(window).off('blur.before-image-upload');
            $(window).off('focus.image-upload');
          }, 10);
        });
      });
    });

    $('#image-upload').change(async () => {
      try {
        // ファイル名を取得
        var file = $('#image-upload').prop('files')[0];

        if (!file) {
          return;
        }
        $('#image-upload').replaceWith($('#image-upload').clone(true));

        if (!(await fileTypeCheck(file))) {
          // メッセージ内容
          //  選択可能な画像形式は「JPEG、GIF、PNG」ファイルです
          self.showPopupMessage(messageUtility.getMessage('E-000-012'));
          return;
        }

        // 15MB以上はエラー
        if (!(await fileSizeCheck(file))) {
          // メッセージ内容
          //  ファイルアップロードの上限は15MBです。
          //  15MB以下の画像を選択してください。
          self.showPopupMessage(messageUtility.getMessage('E-000-011'));
          return;
        }

        //インジケータ表示
        self.showLoaderBg('');

        const uploadImageRes = await api.uploadImage(
          file,
          drawing.places.getPlaceId()
        );
        self.hideLoaderBg();
        drawing.addImage(uploadImageRes.data.entities.image);
      } finally {
        // 同じファイルが設定されるとchangeイベントが発生しないので必ず消す
        $('#image-upload').val('');
      }
    });

    // ツールバー 印刷範囲設定 ボタン
    $('.sys_open_print_range').click(function() {
      if (!$('.print-renge-setting').hasClass('show')) {
        self.setPointerReset();
        self.showPrintRengeSetting();
        ui.toolboxSelect('tool-print-range');
        drawing.showPrintFrame(drawing.getPrintRange());
        $(
          '.toolbar-cut, .toolbar-copy, .toolbar-move-front, .toolbar-move-back, .toolbar-lock, .toolbar-delete'
        )
          .closest('.layout-tool__item')
          .addClass('pointer-events-none');
      }
      $(this).addClass('selected');
    });
    // 印刷範囲設定時 範囲確定 リンク
    $('.sys_save_print_range').click(function() {
      drawing.savePrintRange();
      ui.toolboxSelect(drawing.historyTool);
      $('.sys_open_print_range').removeClass('selected');
    });
    // 印刷範囲設定時 デフォルトに戻す リンク
    $('.sys_default_print_range').click(function() {
      drawing.backPrintFrameDefault();
    });
    // 印刷範囲設定時 やめる リンク
    $('.sys_cancel_print_range').click(function() {
      ui.toolboxSelect(drawing.historyTool);
      $('.sys_open_print_range').removeClass('selected');
    });

    // 職長作業ロック ON|OFF リンク
    $('.sys_lock_room').click(function() {
      if (
        $(this)
          .find('.lock')
          .hasClass('locked')
      ) {
        // ロック解除確認 ダイアログ 表示
        $('#modal-dialog-unlock-okng').addClass('show');
      } else {
        // ロック確認 ダイアログ 表示
        $('#modal-dialog-lock-okng').addClass('show');
      }
    });
    // ロック確認 ダイアログ いいえ ボタン
    $('#modal-dialog-lock-okng .sys_cancel').click(function() {
      $('#modal-dialog-lock-okng').removeClass('show');
    });
    // ロック確認 ダイアログ はい ボタン
    $('#modal-dialog-lock-okng .sys_submit').click(function() {
      $('#modal-dialog-lock-okng').removeClass('show');
      self.showPopupMessage('職長に対してロック設定を行いました。');
      drawing.client.lockRoom(true);
    });
    // ロック解除確認 ダイアログ いいえ ボタン
    $('#modal-dialog-unlock-okng .sys_cancel').click(function() {
      $('#modal-dialog-unlock-okng').removeClass('show');
    });
    // ロック解除確認 ダイアログ はい ボタン
    $('#modal-dialog-unlock-okng .sys_submit').click(function() {
      $('#modal-dialog-unlock-okng').removeClass('show');
      self.showPopupMessage('職長に対してロック設定を解除しました。');
      drawing.client.lockRoom(false);
    });

    // ツールバー 背景変更 ボタン
    $('.select-bg-image').click(function() {
      $('#modal-dialog-select-bg-image').addClass('show');
      $('.select-bg-image').addClass('selected');
    });

    // 背景選択 ダイアログ 戻る ボタン
    $('#modal-dialog-select-bg-image .sys_cancel').click(function() {
      $('#modal-dialog-select-bg-image').removeClass('show');
      $('.select-bg-image').removeClass('selected');
    });
    // 背景選択 ダイアログ クリアする ボタン
    $('#modal-dialog-select-bg-image .sys_clear').click(function() {
      $('#modal-dialog-select-bg-image').removeClass('show');
      $('#modal-dialog-clearvackground-okng').addClass('show');
    });
    // 背景クリア確認 ダイアログ はい ボタン
    $('#modal-dialog-clearvackground-okng .sys_submit').click(function() {
      drawing.clearBackgroundImage();
      $('#modal-dialog-clearvackground-okng').removeClass('show');
    });
    // 背景クリア確認 ダイアログ いいえ ボタン
    $('#modal-dialog-clearvackground-okng .sys_cancel').click(function() {
      $('#modal-dialog-clearvackground-okng').removeClass('show');
    });

    // 背景選択 ダイアログ 変更する ボタン
    $('#bgimage-upload').change(async () => {
      try {
        // ファイル名を取得
        var file = $('#bgimage-upload').prop('files')[0];

        if (!file) {
          return;
        }
        $('#bgimage-upload').replaceWith($('#bgimage-upload').clone(true));

        if (!(await fileTypeCheck(file, ['jpg', 'png', 'gif', 'pdf']))) {
          // メッセージ内容
          //  選択可能な画像形式は「PDF、JPEG、GIF、PNG」ファイルです
          self.showPopupMessage(messageUtility.getMessage('E-000-045'));
          return;
        }
        // 15MB以上はエラー
        if (!(await fileSizeCheck(file))) {
          // メッセージ内容
          //  ファイルアップロードの上限は15MBです。
          //  15MB以下の画像を選択してください。
          if (file.type === 'application/pdf') {
            self.showPopupMessage(messageUtility.getMessage('E-000-044'));
          } else {
            self.showPopupMessage(messageUtility.getMessage('E-000-011'));
          }
          return;
        }

        // インジケータ表示
        self.showLoaderBg('');

        $('#modal-dialog-select-bg-image').removeClass('show');
        $('#modal-dialog-preview-bg-image').addClass('show');
        let result = document.querySelector('.cropper-preview');
        result.innerHTML = '';
        let bgCanvas = document.createElement('canvas');
        bgCanvas.id = 'bg-canvas';
        result.appendChild(bgCanvas);
        let fabricCanvasBg = new fabric.Canvas('bg-canvas', {
          preserveObjectStacking: 'true',
        });
        if (file.type === 'application/pdf') {
          // pdf
          cropperImage.readFilePDF(fabricCanvasBg, file, result);
        } else {
          // image
          cropperImage.readFileImage(fabricCanvasBg, file);
        }

        self.hideLoaderBg();
      } finally {
        // 同じファイルが設定されるとchangeイベントが発生しないので必ず消す
        $('#bgimage-upload').val('');
      }
    });

    $('.close').click(function() {
      self.hideLoaderBg();
      $('#modal-dialog-preview-bg-image').removeClass('show');
      $('.select-bg-image').removeClass('selected');
    });

    async function submitCroppedImage() {
      let srcImage = $('#preview').attr('src');
      try {
        const blob = cropperImage.dataURLtoBlob(srcImage);
        const fileName = `croppedImage.${blob.type.split('/')[1]}`;
        const file = cropperImage.blobToFile(blob, fileName);
        await uploadCroppedFile(file);
      } catch (error) {
        console.error(error);
        $('#modal-dialog-preview-bg-image').removeClass('show');
        ui.hideLoaderBg();
        ui.showPopupMessage(messageUtility.getMessage('E-000-021'));
      }
    }

    async function uploadCroppedFile(file) {
      const uploadBgImageRes = await api.uploadBgImage(
        file,
        drawing.places.getPlaceId()
      );
      self.hideLoaderBg();
      drawing.setBackgroundFile(uploadBgImageRes.data.entities.image);
      $('#modal-dialog-preview-bg-image').removeClass('show');
    }

    $('#submitPreview').on('click', async function() {
      $(this).prop('disabled', true);
      await submitCroppedImage();
      $('.select-bg-image').removeClass('selected');
      $(this).prop('disabled', false);
    });

    // 画面分割時 場所選択 プルダウンメニュー
    $('[name="split_view_place"]').click(function() {
      $(
        '.split-view-select-place .dropdown .dropdown-single-select__scroll'
      ).show();
      $(this)
        .closest('.split-view-select-place')
        .find('.dropdown')
        .addClass('show');
      /**
       *  iPad safariのz-index不具合対応
       *  6分割、9分割時、画面右下のカレンダーを開いた際
       *  カレンダーが隠れないようツールバーを非表示にする
       */
      if (
        ($(this)
          .closest('.split-canvas')
          .hasClass('sys_cell_8') ||
          $(this)
            .closest('.split-canvas')
            .hasClass('sys_cell_5')) &&
        isIPad()
      ) {
        $('.layout-tool-footer').hide();
      }
      let splitNo = $(this)
        .closest('.split-canvas')
        .attr('data-splitno');
      let placeId = $(this)
        .closest('.split-view-select-place')
        .find('[name=split_view_place_id]')
        .val();
      $(`#construction-radio${splitNo}-${placeId}`).prop('checked', true);
    });
    $(document).click(function(e) {
      if ($('.split-view-select-place .dropdown').hasClass('show')) {
        if (!$(e.target).closest('.split-view-select-place').length) {
          $('.split-view-select-place .dropdown').removeClass('show');
        }
      }
    });

    $(document).on('touchstart', function(e) {
      if ($('.split-view-select-place .dropdown').hasClass('show')) {
        if (!$(e.target).closest('.split-view-select-place').length) {
          $('.split-view-select-place .dropdown').removeClass('show');
          $(
            '.split-view-select-place .dropdown .dropdown-single-select__scroll'
          ).hide();
          $('.layout-tool-footer').show();
        }
      }
    });

    // 画面分割時 場所選択 プルダウンメニュー 場所名を入力して検索 入力
    $('[name=split_view_search_place]').change(function() {
      let word = $(this).val();
      let self = this;
      let hasData = false;
      _.each(
        $(this)
          .closest('.split-view-select-place')
          .find('.dropdown .place_item'),
        function(item) {
          let name = $(item).attr('data-name');
          if (name.indexOf(word) >= 0 || word === '') {
            hasData = true;
            $(item).show();
          } else {
            $(item).hide();
          }
        }
      );
      hasData
        ? $(self)
            .closest('.split-view-select-place')
            .find('.dropdown .table-has-no-data')
            .hide()
        : $(self)
            .closest('.split-view-select-place')
            .find('.dropdown .table-has-no-data')
            .show();
    });

    // 画面分割時 場所選択 上ボタン
    $('.sys-split-view-place-down').click(function() {
      var splitView = $(this).closest('.layout-canvas');
      var beforePlaceId = $(splitView)
        .find('[name=split_view_place_id]')
        .val();
      beforePlaceId = beforePlaceId ? beforePlaceId : drawing.places._selectId;
      let tmpPlace = '';
      _.each(drawing.places._placeList, function(place) {
        if (place.id == beforePlaceId && tmpPlace !== '') {
          $(splitView)
            .find('[name=split_view_place_id]')
            .val(tmpPlace.id);
          $(splitView)
            .find('[name=split_view_place]')
            .val(tmpPlace.name);
          self.updateSplitView(splitView);
          return false;
        }
        tmpPlace = place;
      });
    });

    //  画面分割時 場所選択 下ボタン
    $('.sys-split-view-place-up').click(function() {
      var splitView = $(this).closest('.layout-canvas');
      var beforePlaceId = $(splitView)
        .find('[name=split_view_place_id]')
        .val();
      beforePlaceId = beforePlaceId ? beforePlaceId : drawing.places._selectId;
      let flag = false;
      _.each(drawing.places._placeList, function(place) {
        if (flag) {
          $(splitView)
            .find('[name=split_view_place_id]')
            .val(place.id);
          $(splitView)
            .find('[name=split_view_place]')
            .val(place.name);
          self.updateSplitView(splitView);
          return false;
        }
        if (place.id == beforePlaceId) {
          flag = true;
        }
      });
    });

    // ツールバー 画面分割 メニュー 項目
    $('.select_split_number').click(function() {
      const numberScreen = $(this).attr('data-id');
      let pointerType = '';
      if (
        numberScreen !== '1' &&
        $('.tool-object-list-pointer li.selected').attr('data-id')
      ) {
        pointerType = $('.tool-object-list-pointer li.selected').attr(
          'data-id'
        );
      }
      // 印刷範囲の選択フレームを非表示
      drawing.hidePrintFrame();
      // 印刷範囲ツールボタンの非表示
      $('.print-renge-setting').removeClass('show');
      drawing.split.setSplit(parseInt(numberScreen));
      if (parseInt(numberScreen) === 1) {
        $(
          '#tab-tool-home .layout-tool__item, #tab-tool-edit .layout-tool__item'
        ).removeClass('pointer-events-none');
        drawing.setToolbarItem();
        $('[data-id="tool-pointer-button"]').removeClass('selected');
      } else {
        $(
          '#tab-tool-home .layout-tool__item, #tab-tool-edit .layout-tool__item'
        ).addClass('pointer-events-none');
        $('#tab-tool-home .layout-tool__item .selected').removeClass(
          'selected'
        );
        // Only tool pointer and print will not be disabled when screen number > 1
        self.setToolbarButtonEnable('tool-pointer-button', true);
        self.setToolbarButtonEnable('toolbar-canvas-copy-popup', true);
      }
      setTimeout(() => {
        self.checkToolPointer(pointerType);
      }, 50);
    });

    // 画面分割時 左(日付前へ) ボタン
    $('.sys_navi_prev').click(function(e) {
      e.stopPropagation();
      drawing.split.setPage(-1);
    });
    // 画面分割時 右(日付次へ) ボタン
    $('.sys_navi_next').click(function(e) {
      e.stopPropagation();
      drawing.split.setPage(1);
    });
    // 画面分割時 日付変更 プルダウンメニュー
    $('[name=split_view_date]').change(function() {
      var splitView = $(this).closest('.layout-canvas');
      self.updateSplitView(splitView);
    });

    // 画面分割時 キャンバスクリック
    $('.split-canvas .layout-canvas__workspace').click(function(e) {
      e.stopPropagation();
      var dt = $(this)
        .closest('.split-canvas')
        .find('[name=split_view_date]')
        .val()
        ? new Date(
            $(this)
              .closest('.split-canvas')
              .find('[name=split_view_date]')
              .val()
          )
        : new Date();
      var place_id = $(this)
        .closest('.split-canvas')
        .find('[name=split_view_place_id]')
        .val();
      place_id = place_id ? place_id : drawing.places._selectId;
      var name = $(this)
        .closest('.split-canvas')
        .find('[name=split_view_place]')
        .val();
      name = name ? name : drawing.places._selectName;
      $('#modal-dialog-split-view [name=split_date]').val(dt);
      $('#modal-dialog-split-view [name=split_place_id]').val(place_id);
      $('#modal-dialog-split-view [name=split_place]').val(name);
      $('#modal-dialog-split-view').addClass('show');
    });
    // 画面分割時 キャンバスクリック 表示対象を選択 ダイアログ 戻る ボタン
    $('#modal-dialog-split-view .sys_cancel').click(function() {
      $('#modal-dialog-split-view').removeClass('show');
    });
    // 画面分割時 キャンバスクリック 表示対象を選択 ダイアログ 編集する ボタン
    $('#modal-dialog-split-view .sys_edit').click(function() {
      var dt = new Date($('#modal-dialog-split-view [name=split_date]').val());
      var place_id = $('#modal-dialog-split-view [name=split_place_id]').val();
      var name = $('#modal-dialog-split-view [name=split_place]').val();
      $('#modal-dialog-split-view [name=split_date]').val(dt);
      ui.toolboxSelect('tool-pan');
      drawing.split.goEdit(place_id, name, dt);
      $('#modal-dialog-split-view').removeClass('show');
      $(
        '#tab-tool-home .layout-tool__item, #tab-tool-edit .layout-tool__item'
      ).removeClass('pointer-events-none');
      $('.tool-pan').addClass('selected');
      drawing.setToolbarItem();
    });

    // 画面分割時 日付順/場所順(ソート) リンク
    $('.order_type button').click(function() {
      if (!$(this).hasClass('layout__inactive')) {
        return;
      }
      $(this).removeClass('layout__inactive');
      if ($(this).hasClass('sortdate')) {
        $('.order_type .sortplace').addClass('layout__inactive');
        drawing.split.setOrderBy('date');
      }
      if ($(this).hasClass('sortplace')) {
        $('.order_type .sortdate').addClass('layout__inactive');
        drawing.split.setOrderBy('place');
      }
    });

    // ツールバー 別日/別場所からコピー ボタン
    $('.sys_popup_copy').click(function() {
      $('#modal-dialog-copy-select [name=copy_place_id]').val(
        drawing.places.getPlaceId()
      );
      $('#modal-dialog-copy-select [name=copy_place_name]').val(
        drawing.places.getPlaceName()
      );
      $('#modal-dialog-copy-select .copy_place_name_label').text(
        drawing.places.getPlaceName()
      );
      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      $('#modal-dialog-copy-select [name=copy_date]').val(
        util.dataFormat(currentDate, 'YYYY/MM/DD')
      );
      places._copyPlaceId = '';
      $('.sys_popup_copy').addClass('selected');
      // コピー元を選択 ダイアログ を開く
      $('#modal-dialog-copy-select').addClass('show');
    });
    // コピー元を選択 ダイアログ 戻る ボタン
    $('#modal-dialog-copy-select .sys_cancel').click(function() {
      $('#modal-dialog-copy-select').removeClass('show');
      $('.sys_popup_copy').removeClass('selected');
    });
    // コピー元を選択 ダイアログ 選択をコピーする ボタン
    $('#modal-dialog-copy-select .sys_submit').click(function() {
      var placeId = $('#modal-dialog-copy-select [name="copy_place_id"]').val();
      var dateVal = $('#modal-dialog-copy-select [name="copy_date"]').val();
      if (!dateVal) {
        // toastShowMessage("日付を設定してください");
        return;
      }
      var dt = new Date(dateVal);
      var room_id = util.getRoomId(placeId, dt);
      if (!placeId) {
        // toastShowMessage("場所を設定してください");
        return;
      }
      //インジケータ表示
      drawing.client.copy(room_id);
      $('#modal-dialog-copy-select').removeClass('show');
      $('.sys_popup_copy').removeClass('selected');
    });

    $(
      '#modal-dialog-clearvackground-okng .sys_cancel, #modal-dialog-clearvackground-okng .sys_submit'
    ).click(function() {
      $('.select-bg-image').removeClass('selected');
    });
    // コピー元を選択 ダイアログ 場所 プルダウンメニュー
    $('.copy_place_name_label').click(function() {
      $('.select-copy-place')
        .find('.dropdown')
        .addClass('show');
      const selectId =
        places._copyPlaceId !== ''
          ? places._copyPlaceId
          : drawing.places._selectId;
      $(`#construction-radio-copy-${selectId}`).prop('checked', true);
    });
    $(document).click(function(e) {
      // コピー元を選択 ダイアログ 場所 プルダウンメニュー 閉じる処理
      if ($('.select-copy-place .dropdown').hasClass('show')) {
        if (!$(e.target).closest('.select-copy-place').length) {
          $('.select-copy-place .dropdown').removeClass('show');
        }
      }
    });

    //Keep some elements fixed on screen when open/close navi menu
    $('.btn-rail-navi, .btn-rail-master-navi').click(function() {
      let nowTranformX = self.calcTransformXRailMain();
      let closeNavi = $(this)
        .closest('.rail__side')
        .hasClass('show');
      let nextTranformX = closeNavi ? nowTranformX - 210 : nowTranformX + 210;
      if (self.isIE()) {
        $('.layout-tool, .layout-tool-fix').css({
          left: `${nextTranformX}px`,
        });
      }
    });

    $('#func-navi--item1-btn-open').click(function() {
      $('.layout-header__title').css({
        textIndent: '6px',
      });
    });
    $('#func-navi--item1-btn-close').click(function() {
      $('.layout-header__title').css({
        textIndent: '40px',
      });
    });
    // correct Ipad layout
    if (isIPad()) {
      self.correctIpadLayout();
    } else {
      $('.layout-tool-footer').css({
        bottom: '16px',
      });
    }
    // correct IE layout
    if (self.isIE()) {
      self.correctIELayout();
    }
    // correct layout if user is a partner role
    $('.sys_fullscreen').css({
      marginRight: isPartnerCompany(userinfo.getUserType())
        ? '0'
        : isIPad()
        ? '8px'
        : '32px',
    });
    // hide dropdown list when click on item
    // except parts groups
    $('.tool-item--sm input, .tool-item--sm span')
      .off('click.item')
      .on('click.item', function() {
        $(this)
          .closest('.tool-item--sm')
          .toggleClass('selected');
      });
    $('.dropdown-tool-list.parts_group_list').click(function(e) {
      e.stopPropagation();
    });
    $('.dropdown-tool-list li.dropdown-tool-list__item').click(function(e) {
      e.stopPropagation();
      $('.tool-item--sm.selected').removeClass('selected');
    });

    // hover on label, change the background color of button
    $('.layout-tool__label').hover(
      function() {
        $(this)
          .siblings('button.tool-btn')
          .css({
            backgroundColor: '#C2DDFF',
          });
        $(this)
          .siblings()
          .find('button.tool-btn')
          .css({
            backgroundColor: '#C2DDFF',
          });
      },
      function() {
        $(this)
          .siblings('button.tool-btn')
          .css({
            backgroundColor: '',
          });
        $(this)
          .siblings()
          .find('button.tool-btn')
          .css({
            backgroundColor: '',
          });
      }
    );
  };

  // ツールメニュー選択
  this.toolboxSelect = function(modeName) {
    var self = this;

    // 選択可能なツールIDのみ指定できることとする
    // 画面のツールボタンの左側から
    assert(
      [
        'tool-select',
        'tool-font',
        'tool-image',
        'tool-parts',
        'tool-circle',
        'tool-square',
        'tool-polygon',
        'tool-sector',
        'tool-line-normal',
        'tool-solid_line',
        'tool-dotted-line',
        'tool-dashed-line',
        'tool-polyline',
        'tool-freehand',
        'tool-pan', // 背景移動
        'tool-pointer',
        'tool-arrow-pointer',
        'tool-print-range', // 印刷範囲設定
      ].includes(modeName),
      `ui. toolboxSelect don't allow the argument id:${modeName}. Please path the allowed id to this method.`
    );

    // 印刷範囲設定中なら解除する
    if (
      drawing._toolbox_selected === 'tool-print-range' &&
      !['tool-solid_line', 'tool-dotted-line', 'tool-dashed-line'].includes(
        modeName
      )
    ) {
      drawing.hidePrintFrame({ selectHistoryTool: false });
      self.hidePrintRengeSetting();
    }

    // 部品選択状態の解除
    if (modeName !== 'tool-parts') {
      $('.parts').removeClass('selected');
    }

    // ツールバー選択状態の解除
    $('.sys_tooltip').removeClass('selected');
    $('[data-id="tool-parts-button"]').removeClass('selected');
    $('[data-id="tool-shape-button"]').removeClass('selected');
    $('[data-id="tool-line-button"]').removeClass('selected');
    $('[data-id="tool-pointer-button"]').removeClass('selected');
    //ボタンをデフォルトに戻す
    $(
      '.tool-object-icon, .tool-line-icon, .tool-pointer-icon, .selected-object-label, .selected-line-label, .selected-pointer-label'
    ).hide();
    $('.icon-default').show();

    // 描画のパレットを閉じる
    if (modeName !== 'tool-freehand') {
      window.dispatchEvent(new Event('closeFreehandPalette'));
    }

    function hideIconsAndShow(selectorToHide, labelSelector, selectorToShow) {
      $(selectorToHide).hide();
      if (labelSelector) {
        $(labelSelector).hide();
      }
      $(selectorToShow).show();
    }

    switch (modeName) {
      case 'tool-print-range':
        if (
          !['tool-pointer', 'tool-arrow-pointer'].includes(
            drawing._toolbox_selected
          )
        ) {
          drawing.historyTool = drawing._toolbox_selected;
        }
        // 印刷範囲設定の前にポインタ(通常/矢印)の場合は
        // 前回選択ツールの historyTool はすでに設定済みなので更新しない。
        break;

      case 'tool-pointer':
        if (
          !['tool-print-range', 'tool-arrow-pointer'].includes(
            drawing._toolbox_selected
          )
        ) {
          drawing.historyTool = drawing._toolbox_selected;
        }
        // ポインタ切替時の前に印刷範囲設定かポインタ矢印の場合は
        // 前回選択ツールの historyTool はすでに設定済みなので更新しない。
        hideIconsAndShow('.tool-pointer-icon', '', '.icon-circle-s2');
        self.setPointerNomal();
        break;
      case 'tool-arrow-pointer':
        $('[data-id="tool-pointer-button"]').addClass('selected');
        $('[data-id="tool-arrow-pointer"]').addClass('selected');
        hideIconsAndShow(
          '.tool-pointer-icon',
          '.selected-pointer-label',
          '.icon-arrow-pointer'
        );
        self.setPointerArrow();
        break;
      case 'tool-parts':
        $('[data-id="tool-parts-button"]').addClass('selected');
        break;

      case 'tool-circle':
        $('[data-id="tool-shape-button"]').addClass('selected');
        $('[data-id="tool-circle"]').addClass('selected');
        hideIconsAndShow(
          '.tool-object-icon',
          '.selected-object-label',
          '.icon-circle'
        );
        break;
      case 'tool-square':
        $('[data-id="tool-shape-button"]').addClass('selected');
        $('[data-id="tool-square"]').addClass('selected');
        hideIconsAndShow(
          '.tool-object-icon',
          '.selected-object-label',
          '.icon-square'
        );
        break;
      case 'tool-polygon':
        $('[data-id="tool-shape-button"]').addClass('selected');
        $('[data-id="tool-polygon"]').addClass('selected');
        hideIconsAndShow(
          '.tool-object-icon',
          '.selected-object-label',
          '.icon-polygon'
        );
        break;
      case 'tool-sector':
        $('[data-id="tool-shape-button"]').addClass('selected');
        $('[data-id="tool-sector"]').addClass('selected');
        hideIconsAndShow(
          '.tool-object-icon',
          '.selected-object-label',
          '.icon-sector'
        );
        break;

      case 'tool-line-normal':
        $('[data-id="tool-line-button"]').addClass('selected');
        $('[data-id="tool-line-normal"]').addClass('selected');
        hideIconsAndShow(
          '.tool-line-icon',
          '.selected-line-label',
          '.icon-line-normal'
        );
        break;
      case 'tool-solid_line':
      case 'tool-dotted-line':
      case 'tool-dashed-line':
        $('[data-id="tool-line-style-button"]').removeClass('selected');
        $(`[data-id=${modeName}]`).removeClass('selected');
        break;
      case 'tool-polyline':
        $('[data-id="tool-line-button"]').addClass('selected');
        $('[data-id="tool-polyline"]').addClass('selected');
        hideIconsAndShow(
          '.tool-line-icon',
          '.selected-line-label',
          '.icon-polyline'
        );
        break;
      case 'tool-freehand':
        $('[data-id="tool-freehand"]').addClass('selected');
        // 描画のパレットを開く
        window.dispatchEvent(new Event('openFreehandPalette'));
        break;

      default:
        $('.sys_tooltip').each(function() {
          const element = $(this);
          if (element.attr('data-id') === modeName) {
            element.addClass('selected');
          }
        });
        break;
    }
    $('.sys_open_print_range, .toolbar-canvas-copy-popup').removeClass(
      'selected'
    );
    if (
      !_.includes(
        ['tool-solid_line', 'tool-dotted-line', 'tool-dashed-line'],
        modeName
      )
    ) {
      drawing.toolboxSelect(modeName);
    }
  };

  // ローディング画面表示
  this.showLoaderBg = function(messageId) {
    $('.layout-tool, .layout-grid').hide();
    $('.layout.loading').show();
    $('.loading-message').hide();
    if (messageId !== '') {
      $(`.loading-message#${messageId}`).show();
    }
  };
  // ローディング画面非表示
  this.hideLoaderBg = function() {
    $('.layout.loading')
      .delay(200)
      .fadeOut(200);
    $('.layout.loading .loading-message')
      .delay(100)
      .fadeOut(100);
    if ($('.rail').hasClass('rail--layout-fullscreen-noheader')) {
      $('.layout-grid')
        .delay(400)
        .fadeIn(200);
    } else {
      $('.layout-tool, .layout-grid')
        .delay(400)
        .fadeIn(200);
    }
  };

  // 印刷モーダルを閉じる処理
  this.printClose = function() {
    this.closePrintDialog();
    this.hideLoadingMessage();
    $('#modal-dialog-print .sys_print').prop('disabled', false);
    $('.toolbar-canvas-copy-popup').prop('disabled', false);
  };

  // メッセージ表示
  this.showPopupMessage = function(message) {
    $('#modal-dialog-popup-message .message_text').html(message);
    $('#modal-dialog-popup-message').addClass('show');
  };

  // メッセージ表示後、場所一覧へ戻る
  this.gobackPlaceList = function(message) {
    $('#modal-dialog-goback-placeList .message_text').html(message);
    $('#modal-dialog-goback-placeList').addClass('show');
  };

  // メッセージ表示
  this.showLoadingMessage = function(message) {
    $('#modal-loading-popup-message .message_text').html(message);
    $('#modal-loading-popup-message').addClass('show');
  };

  // 印刷ダイアログを閉じる
  this.closePrintDialog = function() {
    $('#modal-dialog-print').removeClass('show');
  };

  this.hideLoadingMessage = function() {
    $('#modal-loading-popup-message .message_text').html('');
    $('#modal-loading-popup-message').removeClass('show');
  };

  this.showCopyNodataMessage = function() {
    $('#modal-dialog-copy-nodata').addClass('show');
    $('#modal-dialog-copy-nodata .sys_cancel').click(function() {
      $('#modal-dialog-copy-nodata').removeClass('show');
    });
  };

  // ポインタ制御
  this.setPointerReset = function() {
    $('[data-id="tool-pointer-button"]').removeClass('selected');
    $('.layout-canvas').removeClass('__is-pointer');
    $('.layout-canvas').removeClass('__is-arrow-pointer');
  };
  this.setPointerNomal = function() {
    $('[data-id="tool-pointer-button"]').addClass('selected');
    $('[data-id="tool-pointer"]').addClass('selected');
    $('.layout-canvas').removeClass('__is-arrow-pointer');
    $('.layout-canvas').addClass('__is-pointer');
  };
  this.setPointerArrow = function() {
    $(this).find('.circle-icon');
    $('[data-id="tool-pointer-button"]').addClass('selected');
    $('[data-id="tool-arrow-pointer"]').addClass('selected');
    $('.layout-canvas').removeClass('__is-pointer');
    $('.layout-canvas').addClass('__is-arrow-pointer');
  };

  // オブジェクトステータス変更
  // 線幅を設定
  this.setBorderWidth = function(w) {
    this.dropdownBorder.setValue(w, false);
  };

  // 線種を設定
  this.setBorderStyle = function(st) {
    let list = { 1: '実線', 2: '点線', 3: '鎖線' };
    $(`button.tool-line-style-button[data-value=${st}]`).css({
      display: 'flex',
    });
    $(`button.tool-line-style-button[data-value!=${st}]`).hide();
    this.dropdownBorderStyle.setValue(list[st], false);
  };

  // 矢印を設定
  this.setArrowType = function(atp) {
    this.dropdownBorderArrow.setValue(atp, false);
  };

  // 矢印サイズを設定
  this.setArrowSize = function(asz) {
    this.dropdownBorderArrowSize.setValue(asz, false);
  };

  // 文字サイズを設定
  this.setFontSize = function(fsz) {
    var sz = fsz / 1.5;
    this.dropdownFontSize.setValue(sz, false);
  };

  // 透明度を設定
  this.setBackgroundTransparent = function(tp) {
    this.dropdownTransparent.setValue(tp, false);
  };

  // 線色を設定
  this.setForegroundColor = function(c) {
    var a = 0;
    if (c.indexOf('rgba') != -1) {
      var split = c.split(',');
      c = `${split[0]},${split[1]},${split[2]})`;
      c = c.replace('rgba', 'rgb');
      a = split[3].replace(')', '').replace(' ', '');
      a = 100 - a * 100;
    }

    var color = new RGBColor(c);
    var _this = $('.toolbar-picker-foreground');
    var _class = _this.find('._selected').attr('class');

    if (_class != undefined) {
      _.each(_class.split(' '), function(value) {
        if (value.match(/^__/g)) {
          _this.find('._selected').removeClass(value);
        }
      });
    }
    if (_class != undefined) {
      _class = _this.find('._selected').attr('class');

      _.each(_class.split(' '), function(value) {
        _this.find('._selected').addClass(value);
      });
    }

    if (a == 100) {
      _this.find('._selected').addClass('__empty');
    } else if (color.toHex() == '#ffffff') {
      _this.find('._selected').addClass('__none');
    } else {
      _this.find('._selected').addClass(`__${color.toHex().replace('#', '')}`);
    }
  };

  // 背景色を設定
  this.setBackgroundColor = function(c) {
    var a = 0;
    if (c.indexOf('rgba') != -1) {
      var split = c.split(',');
      c = `${split[0]},${split[1]},${split[2]})`;
      c = c.replace('rgba', 'rgb');
      a = split[3].replace(')', '').replace(' ', '');
      a = 100 - parseInt(a * 100);
    }

    var color = new RGBColor(c);
    var _this = $('.toolbar-picker-background');
    var _class = _this.find('._selected').attr('class');
    if (_class != undefined) {
      _.each(_class.split(' '), function(value) {
        if (value.match(/^__/g)) {
          _this.find('._selected').removeClass(value);
        }
      });
    }
    if (_class != undefined) {
      _class = _this.find('._selected').attr('class');
      _.each(_class.split(' '), function(value) {
        _this.find('._selected').addClass(value);
      });
    }

    if (color.toHex() === '#ffffff') {
      if (a === 100) {
        _this.find('._selected').addClass('__empty');
      } else {
        _this.find('._selected').addClass('__none');
      }
    } else {
      _this.find('._selected').addClass(`__${color.toHex().replace('#', '')}`);
    }
    this.setBackgroundTransparent(a);
  };

  // 文字色を設定
  this.setTextColor = function(c) {
    var color = new RGBColor(c);
    var _this = $('.toolbar-picker-text');
    var _class = _this.find('._selected').attr('class');
    if (_class != undefined) {
      _.each(_class.split(' '), function(value) {
        if (value.match(/^__/g)) {
          _this.find('._selected').removeClass(value);
        }
      });
    }
    _class = _this.find('._selected').attr('class');
    if (_class != undefined) {
      _.each(_class.split(' '), function(value) {
        _this.find('._selected').addClass(value);
      });
    }
    _this.find('._selected').addClass(`__${color.toHex().replace('#', '')}`);
  };

  // ボタン使用可否設定
  this.setToolbarButtonDisable = function(id) {
    $(`.${id}`).attr('disabled', 'disabled');
    $('.tool-btn').attr('disabled', 'disabled');
  };

  // ボタン使用可否設定
  this.setToolbarButtonEnable = function(id, fg) {
    if (fg) {
      $(`.${id}`)
        .closest('.layout-tool__item')
        .removeClass('pointer-events-none');
    } else {
      $(`.${id}`)
        .closest('.layout-tool__item')
        .addClass('pointer-events-none');
    }
  };
  // ボタン非表示設定
  this.setToolbarButtonShowHide = function(show_id, hide_id) {
    $(`.${show_id}`).show();
    $(`.${hide_id}`).hide();
  };

  // 印刷範囲設定用 ボタンUIパネルの表示
  this.showPrintRengeSetting = function() {
    $('.print-renge-setting').addClass('show');
  };

  // 印刷範囲設定用 ボタンUIパネルの非表示
  this.hidePrintRengeSetting = function() {
    $('.print-renge-setting').removeClass('show');
  };

  // 画面ロック(職長作業ロック)
  this.lockRoom = function(isLocked) {
    var self = this;
    if (isLocked) {
      // 職長作業ロック コントロール 変更
      $('.sys_lock_room .lock').removeClass('unlocked');
      $('.sys_lock_room .lock').addClass('locked');
      if (isPartnerCompany(userinfo.getUserType())) {
        self.toolboxHide();
        ui.toolboxSelect('tool-pan');
        self.showPopupMessage('現場監督により編集機能がロックされています');
      }
    } else {
      $('.sys_lock_room .lock').removeClass('locked');
      $('.sys_lock_room .lock').addClass('unlocked');

      if (!SessionStorageService.isExtraProxiLogin()) {
        self.toolboxShow();

        if (self.toolboxCollapsed) {
          $('.layout-tool').addClass('element__hide');
          $('.toolbar-close').hide();
          $('.toolbar-open').show();
          $('.layout-tool-fix').css({
            height: '24px',
          });
          $('.layout-grid').css({
            paddingTop: '24px',
          });
        }
      }
    }
  };

  // 分割画面更新
  this.updateSplitView = function(splitView) {
    var no = $(splitView).attr('data-splitno');
    var rowId = $(splitView)
      .find('[name=split_view_place_id]')
      .val();
    var name = $(splitView)
      .find('[name=split_view_place]')
      .val();
    var dt = $(splitView)
      .find('[name=split_view_date]')
      .val()
      ? new Date(
          $(splitView)
            .find('[name=split_view_date]')
            .val()
        )
      : new Date();
    drawing.split.setItem(no, rowId, name, dt);
  };

  this.toolboxHide = function() {
    this.isHidingToolbox = true;
    // クラスを追加するのみで削除する処理も入れた方がいい気が・・・
    $('.layout-tool-fix, .btn-toolbar-toggle').hide();
    $('.layout-tool').addClass('element__hide');
    $('.layout-grid').css({
      paddingTop: '0',
    });
  };

  this.toolboxShow = function() {
    this.isHidingToolbox = false;
    $('.layout-tool-fix').show();
    $('.btn-toolbar-toggle').css({
      display: 'flex',
    });
    $('.layout-tool').removeClass('element__hide');
    $('.layout-grid').css({
      paddingTop: '96px',
    });
  };

  // set status (enable/disable) for toolbar's object edit tab
  this.setStatusToolbarObjectEditTab = function(hasObjectSelected) {
    const $tabToolEditLink = $('#tab-tool-edit__link');
    const $tabToolEdit = $('#tab-tool-edit');
    const $tabToolHomeLink = $('#tab-tool-home__link');
    const $tabToolHome = $('#tab-tool-home');
    if (hasObjectSelected) {
      $tabToolEditLink.removeClass('disable');
      $tabToolHomeLink.removeClass('active');
      $tabToolHome.removeClass('active');
      $tabToolEditLink.addClass('active');
      $tabToolEdit.addClass('active');
    } else {
      $tabToolEditLink.removeClass('active');
      $tabToolEditLink.addClass('disable');
      $tabToolEdit.removeClass('active');
      $tabToolHomeLink.addClass('active');
      $tabToolHome.addClass('active');
    }
    // カスタムイベントを発火してReactコンポーネントに通知
    const event = new CustomEvent(EventType.LAYOUT_LOADING, {
      detail: { hasObjectSelected },
    });
    window.dispatchEvent(event);
  };

  // calculate sum tranform of canvas edit div
  this.calcTransformXRailMain = function() {
    let sumTransformX = 0;
    $('.rail__main').each(function(index, obj) {
      if ($(obj).is(':visible')) {
        let transformMaxtrix =
          $(obj).css('-webkit-transform') ||
          $(obj).css('-moz-transform') ||
          $(obj).css('-ms-transform') ||
          $(obj).css('-o-transform') ||
          $(obj).css('transform');
        let matrix = transformMaxtrix.replace(/[^0-9\-.,]/g, '').split(',');
        let transformX = matrix[12] || matrix[4];
        sumTransformX += parseInt(transformX);
      }
    });
    return sumTransformX;
  };

  this.isIE = function() {
    /* MSIE used to detect old browsers and Trident used to newer ones*/
    return (
      navigator.userAgent.indexOf('MSIE ') > -1 ||
      navigator.userAgent.indexOf('Trident/') > -1
    );
  };

  this.correctIpadLayout = function() {
    $('.toolbar-zoomup, .toolbar-zoomdown, .tool-multiscreen')
      .siblings('.layout-tool__label')
      .css({
        marginTop: '-2px',
      });
    $('.Palette').css({
      marginTop: '2px',
      marginBottom: '2px',
    });

    $('.layout-tool__item .input-spin--sm').css({
      margin: '6px 0',
    });

    $('#dropdown-border-section .layout-tool__label .label span').css({
      top: '-10px',
    });

    $('.sys_fullscreen').css({
      marginRight: isPartnerCompany(userinfo.getUserType()) ? '0' : '8px',
    });

    $('#dropdown-zoom-level').css({
      marginTop: '-2px',
    });

    $('.layout-tool-footer .label_footer_order_type').css({
      marginTop: '8px',
    });

    $(
      '.split-view-select-place .dropdown .dropdown-single-select__scroll'
    ).hide();
    $('.select-place .dropdown .dropdown-single-select__scroll').hide();

    this.correctLayoutFooter(self._fullScreen);
    this.resizeHeader(window.innerHeight > window.innerWidth);
  };
  this.correctIELayout = function() {
    $(
      '.layout-select-header .layout-select-header__item .dropdown-calender--layout-select-header .dropdown-calender__input input[type=text]' +
        ', .layout-select-header .layout-select-header__item .dropdown-single-select--layout-select-header .dropdown-single-select__header input[type=text]'
    ).css({
      textIndent: `8px`,
    });
    $('#dropdown-border-section .layout-tool__label').css({
      marginTop: '-3px',
    });
  };

  this.resizeHeader = function(isVertical) {
    if (isVertical) {
      $(
        '.layout-header__fullscreen, .layout-header__lock, .fullscreen .fullscreen__text, .lock .lock__text'
      ).css({
        fontSize: '12px',
      });
      $('.layout-header .layout-header__menu .layout-header__info').css({
        fontSize: '12px',
        textIndent: '10px',
      });
      $('.layout-header .layout-header__menu .layout-header__close-button').css(
        {
          fontSize: '12px',
          textIndent: '10px',
        }
      );
      $('.layout-header .layout-header__menu').css({
        right: '6px',
      });
      $('.layout-header .layout-header__title').css({
        fontSize: '14px',
      });
      $('.sys_fullscreen').css({
        marginRight: isPartnerCompany(userinfo.getUserType()) ? '0' : '8px',
      });
    } else {
      $(
        '.layout-header__fullscreen, .layout-header__lock, .fullscreen .fullscreen__text, .lock .lock__text'
      ).css({
        fontSize: '14px',
      });
      $('.layout-header .layout-header__menu .layout-header__info').css({
        fontSize: '14px',
        textIndent: '32px',
      });
      $('.layout-header .layout-header__menu .layout-header__close-button').css(
        {
          fontSize: '14px',
          textIndent: '48px',
        }
      );
      $('.layout-header .layout-header__menu').css({
        right: '16px',
      });
      $('.layout-header .layout-header__title').css({
        fontSize: '20px',
      });
      $('.sys_fullscreen').css({
        marginRight: isPartnerCompany(userinfo.getUserType()) ? '0' : '32px',
      });
    }
  };

  this.checkToolPointer = function(type) {
    if (type === 'tool-pointer') {
      ui.setPointerNomal();
    } else if (type === 'tool-arrow-pointer') {
      ui.setPointerArrow();
    } else {
      ui.setPointerReset();
    }
  };

  this.correctLayoutFooter = function(isFullScreen) {
    if (!isIPad()) {
      return;
    }
    const $layoutToolFooter = $('.layout-tool-footer');
    if (isFullScreen) {
      const $globalHeader = $('.global-header');
      $layoutToolFooter.css({
        bottom: '',
        top: `${window.innerHeight -
          $layoutToolFooter.height() -
          $globalHeader.height() -
          16}px`,
      });
    } else {
      $layoutToolFooter.css({
        bottom: '',
        top: `${window.innerHeight - $layoutToolFooter.height() - 16}px`,
      });
    }
  };

  this.checkToolToDisable = function(type) {
    if (
      _.includes(
        [
          'egText',
          'egEllipse',
          'egRect',
          'egPolygon',
          'egLine',
          'egPolyline',
          'egPath',
          'egImage',
          'egSector',
          'customFreehand'
        ],
        type
      )
    ) {
      this.disableToolSettingStyle(type);
    }
  };

  this.disableToolSettingStyle = function(type) {
    $('.tool-setting-style').removeClass('pointer-events-none');
    let $styleElements;
    if (type === 'egText') {
      $styleElements = $(
        '.toolbar-picker-foreground, #dropdown-border-style, #dropdown-border, #dropdown-border-arrow, #dropdown-border-arrow-size'
      );
    } else if (
      _.includes(['egEllipse', 'egRect', 'egPolygon', 'egSector'], type)
    ) {
      $styleElements = $(
        '#dropdown-border-arrow, #dropdown-border-arrow-size, .toolbar-picker-text, #dropdown-font-size'
      );
    } else if (type === 'egLine') {
      $styleElements = $(
        '.toolbar-picker-background, #dropdown-background-transparent, .toolbar-picker-text, #dropdown-font-size'
      );
    } else if (type === 'egPolyline') {
      $styleElements = $('.toolbar-picker-text, #dropdown-font-size');
    } else if (type === 'egPath') {
      $styleElements = $(
        '#dropdown-border-arrow, #dropdown-border-arrow-size, .toolbar-picker-background, #dropdown-background-transparent, .toolbar-picker-text, #dropdown-font-size'
      );
    } else if (type === 'egImage') {
      $styleElements = $('.tool-setting-style');
    } else if (type === 'customFreehand') {
      $styleElements = $(
        '#dropdown-border-arrow, #dropdown-border-arrow-size, #dropdown-border-style, .toolbar-picker-background, #dropdown-background-transparent, .toolbar-picker-text, #dropdown-font-size'
      );
    }

    $styleElements.each(function() {
      $(this)
        .closest('.layout-tool__item')
        .addClass('pointer-events-none');
    });
    this.checkDisableToolLineSize();
  };

  this.enableToolStyleWithTarget = function(type) {
    let styleElements = '';
    if (type === 'egImage') {
      styleElements = '';
    } else if (type === 'egText') {
      styleElements =
        '.toolbar-picker-background, #dropdown-background-transparent, .toolbar-picker-text, #dropdown-font-size';
    } else if (
      _.includes(['egEllipse', 'egRect', 'egPolygon', 'egSector'], type)
    ) {
      styleElements =
        '.toolbar-picker-background, #dropdown-background-transparent, .toolbar-picker-foreground, #dropdown-border-style, #dropdown-border';
    } else if (type === 'egLine') {
      styleElements =
        '.toolbar-picker-foreground, #dropdown-border-style, #dropdown-border, #dropdown-border-arrow';
    } else if (type === 'egPolyline') {
      styleElements =
        '.toolbar-picker-background, #dropdown-background-transparent, .toolbar-picker-foreground, #dropdown-border-style, #dropdown-border, #dropdown-border-arrow';
    } else if (type === 'egPath') {
      styleElements =
        '.toolbar-picker-foreground, #dropdown-border-style, #dropdown-border';
    } else if (type === 'customFreehand') {
      styleElements = '.toolbar-picker-foreground, #dropdown-border';
    }
    if (styleElements !== '') {
      $(styleElements).each(function() {
        $(this)
          .closest('.tool-setting-style')
          .removeClass('pointer-events-none');
      });
      this.checkDisableToolLineSize();
    }
  };

  this.checkDisableMoveFrontOrBack = function(canvas, target) {
    const objects = canvas.getObjects().filter(o => {
      return !o.excludeFromExport;
    });
    const indexObject = objects.indexOf(target);
    const objectsSize = objects.length;
    const groupSize = canvas._objects.length - 1;
    if (objectsSize === 1 || groupSize === 1) {
      this.setToolbarButtonEnable('toolbar-move-front', false);
      this.setToolbarButtonEnable('toolbar-move-back', false);
    } else {
      if (indexObject === objectsSize - 1) {
        this.setToolbarButtonEnable('toolbar-move-front', false);
      } else if (indexObject === 0) {
        this.setToolbarButtonEnable('toolbar-move-back', false);
      } else {
        this.setToolbarButtonEnable('toolbar-move-front', true);
        this.setToolbarButtonEnable('toolbar-move-back', true);
      }
    }
    if (target && target._objects) {
      if (target._objects.length === objectsSize) {
        this.setToolbarButtonEnable('toolbar-move-front', false);
        this.setToolbarButtonEnable('toolbar-move-back', false);
      } else {
        let arr = [];
        let flag = false;
        _.each(target._objects, o => {
          arr.push(objects.indexOf(o));
        });
        arr.sort();
        for (let i = 0; i < arr.length - 1; i++) {
          flag = arr[i] === arr[i + 1] - 1;
        }
        flag &&
          arr[0] === 0 &&
          this.setToolbarButtonEnable('toolbar-move-back', false);
        flag &&
          arr[arr.length - 1] === objectsSize - 1 &&
          this.setToolbarButtonEnable('toolbar-move-front', false);
      }
    }
  };

  this.styleWithTargetLocked = function(statuses) {
    let {
      isSelectOneLock,
      isSelectOneGroupIncludeLock,
      isSelectMultiAnyLock,
      isSelectMultiAllLock,
      canUnlock,
    } = statuses;
    if (
      isSelectOneLock ||
      isSelectOneGroupIncludeLock ||
      isSelectMultiAnyLock ||
      isSelectMultiAllLock
    ) {
      $('.tool-setting-style').addClass('pointer-events-none');
      const disableToolbarLockUnlock = () => {
        this.setToolbarButtonEnable('toolbar-unlock', false);
        this.setToolbarButtonEnable('toolbar-lock', false);
      };
      this.setToolbarButtonEnable('toolbar-move-front', false);
      this.setToolbarButtonEnable('toolbar-move-back', false);
      !canUnlock && disableToolbarLockUnlock();
    }
  };

  this.styleWithGroupLocked = function(statuses) {
    const {
      isSelectOneGroup,
      isSelectOneLock,
      isSelectMultiAllLock,
      isSelectMultiAnyLock,
    } = statuses;
    if (isSelectOneGroup && !isSelectOneLock) {
      $('.tool-setting-style').addClass('pointer-events-none');
    } else if (
      (isSelectOneGroup && isSelectOneLock) ||
      isSelectMultiAllLock ||
      isSelectMultiAnyLock
    ) {
      $('.tool-setting-style').addClass('pointer-events-none');
      this.setToolbarButtonEnable('toolbar-move-front', false);
      this.setToolbarButtonEnable('toolbar-move-back', false);
      this.setToolbarButtonEnable('toolbar-group', false);
      this.setToolbarButtonEnable('toolbar-ungroup', false);
    } else {
      $('.tool-setting-style').removeClass('pointer-events-none');
      this.setToolbarButtonEnable('toolbar-move-front', true);
      this.setToolbarButtonEnable('toolbar-move-back', true);
      this.setToolbarButtonEnable('toolbar-group', true);
      this.setToolbarButtonEnable('toolbar-ungroup', true);
    }
  };

  this.enableToolStyleSwipeObject = function(target) {
    if (target === undefined) {
      return;
    }
    if (target._objects && target.type !== 'customFreehand') {
      $('.tool-setting-style').addClass('pointer-events-none');
      target._objects.forEach(obj => this.enableToolStyleWithTarget(obj.type));
    } else {
      this.enableToolStyleWithTarget(target.type);
    }
  };

  this.checkDisableToolLineSize = function() {
    const objs = drawing._canvas.getActiveObject();
    if (!objs) {
      return;
    }
    let flag = true;
    if (objs._objects) {
      _.each(objs._objects, o => {
        if (o.arrowStart || o.arrowEnd) {
          flag = false;
          return flag;
        }
      });
    } else {
      flag = !(objs.arrowStart || objs.arrowEnd);
    }
    if (flag) {
      $('#dropdown-border-arrow-size')
        .closest('.layout-tool__item')
        .addClass('pointer-events-none');
    } else {
      $('#dropdown-border-arrow-size')
        .closest('.layout-tool__item')
        .removeClass('pointer-events-none');
    }
  };

  this.disableToolWithPrint = function(showPrint) {
    if (showPrint) {
      $(
        '.toolbar-undo, .toolbar-cut, .toolbar-copy, .toolbar-move-front, .toolbar-move-back, .toolbar-lock, .toolbar-delete'
      )
        .closest('.layout-tool__item')
        .addClass('pointer-events-none');
    }
  };

  this.correctInitKeyplanLayout = function() {
    $('.layout-header__menu__keyplan, .layout-tool-footer__keyplan').css({
      opacity: 1,
    });
    $('.layout-header__title').css({
      textIndent: '6px',
    });
    $('.tool-crane__dropdown .tool-crane__body').css({
      left: '220px',
    });
  };
}

export const ui = new _ui();



// WEBPACK FOOTER //
// ./src/canvas/common/ui.js